import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

/* eslint-disable no-shadow */
import Vue from 'vue';
import Vuex from 'vuex';
import MagicService from '@/service/magic';
import { now, userService, loginService } from '@vip-activity/business';
import { shieldRun } from '@vip-activity/utils';
import env from '@tencent/vft-common/env';
import LaiseeService from '@/service/laisee';
import { isToday } from '@/util/helper';
import { isKidAppExisted } from '../util/kid';
import _dailyAdd, { getAdd } from '../service/daily-add';
Vue.use(Vuex);

var getLuckiest = function getLuckiest(list) {
  // 找到天数最多的人的下标
  var maxIndex = 0;

  for (var i = 1; i < list.length; i += 1) {
    maxIndex = list[i].content > list[maxIndex].content ? i : maxIndex;
  }

  if (list[maxIndex].content) {
    return maxIndex;
  } // 全是优惠券等意外情况，不展示手气最佳


  return NaN;
};

function checkError(e) {
  console.debug('checkError', JSON.parse(JSON.stringify(e)));
  var code = e.code; // 登录态问题

  if ([// 未登录
  -102, -11, // 登录态校验错误
  -9901, -10001, -10002].includes(code)) {
    Vue.prototype.toast('登录状态出问题啦，请重新登录');
    setTimeout(function () {
      loginService.openLogin();
    }, 500);
    return;
  }

  Vue.prototype.confirm({
    msg: "\u7EA2\u5305\u8D70\u4E22\u5566\uFF0C\u5237\u65B0\u8BD5\u8BD5\u5427~(".concat(code, ")"),
    confirmText: '好的',
    cancelText: '算了',
    confirm: function confirm() {
      window.location.reload();
    }
  });
}

var todayLasieeLock = null;
var state = {
  now: Date.now(),
  hasGoldBelt: false,
  firstgetGoldBelt: false,
  userRank: null,
  isKidAppInstall: true,
  magicInfo: null,
  todayOrder: '',
  todayLaisee: '',
  receivedLaisee: '',
  fetcherList: [],
  historyRecord: [],
  isOwner: false,
  remainNum: 0,
  lotteryList: [],
  lotteryFlowList: [],
  lotteryNextFlowList: []
};
var mutations = {
  setState: function setState(state, payload) {
    state[payload.state] = payload.value;
  }
};
var actions = {
  // 刷新抽奖信息（抽奖次数）
  refreshLotteryInfo: function refreshLotteryInfo(_ref) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var commit, res, _res$data$left_num, leftNum;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit;
              _context.next = 3;
              return MagicService.getLotteryInfo();

            case 3:
              res = _context.sent;
              _res$data$left_num = res.data.left_num, leftNum = _res$data$left_num === void 0 ? 0 : _res$data$left_num;
              commit('setState', {
                state: 'remainNum',
                value: leftNum
              });

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  // 跑马灯
  getLotteryFlowList: function getLotteryFlowList(_ref2) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _res$data, _res$data$list;

      var commit, res, list;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref2.commit;
              _context2.next = 3;
              return MagicService.lotteryFlowList();

            case 3:
              res = _context2.sent;

              if (((_res$data = res.data) === null || _res$data === void 0 ? void 0 : (_res$data$list = _res$data.list) === null || _res$data$list === void 0 ? void 0 : _res$data$list.length) > 0) {
                commit('setState', {
                  state: 'lotteryFlowList',
                  value: res.data.list
                });
                list = JSON.parse(JSON.stringify(res.data.list));
                list.push(list.shift());
                commit('setState', {
                  state: 'lotteryNextFlowList',
                  value: list
                });
              }

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  getLotteryList: function getLotteryList(_ref3) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var commit, res, _res$data$lottery_lis, lotteryList;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit = _ref3.commit;
              _context3.next = 3;
              return MagicService.getLotteryList();

            case 3:
              res = _context3.sent;
              _res$data$lottery_lis = res.data.lottery_list, lotteryList = _res$data$lottery_lis === void 0 ? [] : _res$data$lottery_lis;
              commit('setState', {
                state: 'lotteryList',
                value: lotteryList
              });

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  },
  dailyAdd: function dailyAdd(_ref4) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var commit, hasGoldBelt, res, _res;

      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              commit = _ref4.commit;

              if (!env.isKidApp) {
                _context4.next = 22;
                break;
              }

              hasGoldBelt = false;
              _context4.prev = 3;
              _context4.next = 6;
              return _dailyAdd();

            case 6:
              res = _context4.sent;
              console.log('dailyAdd', res); // 首次加金腰带成功

              hasGoldBelt = true;
              commit('setState', {
                state: 'firstgetGoldBelt',
                value: true
              });
              _context4.next = 19;
              break;

            case 12:
              _context4.prev = 12;
              _context4.t0 = _context4["catch"](3);

              if (!(_context4.t0.ret === 80001)) {
                _context4.next = 18;
                break;
              }

              hasGoldBelt = true;
              _context4.next = 19;
              break;

            case 18:
              throw _context4.t0;

            case 19:
              commit('setState', {
                state: 'hasGoldBelt',
                value: hasGoldBelt
              });
              _context4.next = 32;
              break;

            case 22:
              _context4.prev = 22;
              _context4.next = 25;
              return getAdd();

            case 25:
              _res = _context4.sent;
              commit('setState', {
                state: 'hasGoldBelt',
                value: !!(_res !== null && _res !== void 0 && _res.bulladd_number)
              });
              _context4.next = 32;
              break;

            case 29:
              _context4.prev = 29;
              _context4.t1 = _context4["catch"](22);
              console.log(_context4.t1);

            case 32:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[3, 12], [22, 29]]);
    }))();
  },
  getNow: function getNow(_ref5) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      var commit, time;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              commit = _ref5.commit;
              time = Date.now();
              _context5.prev = 2;
              _context5.next = 5;
              return now();

            case 5:
              time = _context5.sent;
              _context5.next = 11;
              break;

            case 8:
              _context5.prev = 8;
              _context5.t0 = _context5["catch"](2);
              console.log(_context5.t0);

            case 11:
              commit('setState', {
                state: 'now',
                value: time
              });

            case 12:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[2, 8]]);
    }))();
  },
  createLaisee: function createLaisee(_ref6, orderId) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      var commit, newLaisee;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              commit = _ref6.commit;
              _context6.prev = 1;
              _context6.next = 4;
              return LaiseeService.create({
                orderId: orderId,
                head: userService.headurl,
                nick: userService.nick,
                type: 1
              });

            case 4:
              newLaisee = _context6.sent;
              commit('setState', {
                state: 'todayLaisee',
                value: newLaisee.laisee_id
              });
              _context6.next = 13;
              break;

            case 8:
              _context6.prev = 8;
              _context6.t0 = _context6["catch"](1);
              console.error('createLaisee', _context6.t0); // -10002010: ever has red

              if (_context6.t0.code === -10002010 && _context6.t0.res) {
                commit('setState', {
                  state: 'todayLaisee',
                  value: _context6.t0.res.laisee_id
                });
              }

              Vue.prototype.toast('创建红包失败');

            case 13:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[1, 8]]);
    }))();
  },
  // 获得今日红包信息
  getTodayLaisee: function getTodayLaisee(_ref7) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
      var state, commit, dispatch;
      return regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              state = _ref7.state, commit = _ref7.commit, dispatch = _ref7.dispatch;

              if (!state.todayLaisee) {
                _context8.next = 3;
                break;
              }

              return _context8.abrupt("return", state.todayLaisee);

            case 3:
              if (!todayLasieeLock) {
                _context8.next = 5;
                break;
              }

              return _context8.abrupt("return", todayLasieeLock);

            case 5:
              todayLasieeLock = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
                var orderList, res, laiseeId;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                  while (1) {
                    switch (_context7.prev = _context7.next) {
                      case 0:
                        _context7.prev = 0;
                        _context7.next = 3;
                        return dispatch('getTodayOrder');

                      case 3:
                        console.log('getTodayOrder', state.todayOrder);

                        if (state.todayOrder) {
                          _context7.next = 6;
                          break;
                        }

                        return _context7.abrupt("return");

                      case 6:
                        _context7.next = 8;
                        return LaiseeService.getOrderList();

                      case 8:
                        orderList = _context7.sent;
                        res = orderList.find(function (order) {
                          return order.order_id === state.todayOrder;
                        });
                        console.log('todayLaisee', res); // eslint-disable-next-line camelcase

                        laiseeId = res === null || res === void 0 ? void 0 : res.laisee_id;

                        if (laiseeId) {
                          _context7.next = 14;
                          break;
                        }

                        return _context7.abrupt("return");

                      case 14:
                        // 有对应红包id则保存
                        commit('setState', {
                          state: 'todayLaisee',
                          value: laiseeId
                        });
                        _context7.next = 21;
                        break;

                      case 17:
                        _context7.prev = 17;
                        _context7.t0 = _context7["catch"](0);
                        console.error('getTodayLaisee', _context7.t0);
                        checkError(_context7.t0);

                      case 21:
                        _context7.prev = 21;
                        setTimeout(function () {
                          todayLasieeLock = null;
                        }, 100);
                        return _context7.finish(21);

                      case 24:
                      case "end":
                        return _context7.stop();
                    }
                  }
                }, _callee7, null, [[0, 17, 21, 24]]);
              }))();
              return _context8.abrupt("return", todayLasieeLock);

            case 7:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }))();
  },
  // 获得今日红包资格信息
  getTodayOrder: function getTodayOrder(_ref9) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
      var commit, qualList, todayOrderInfo, todayOrder;
      return regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              commit = _ref9.commit;
              _context9.prev = 1;
              _context9.next = 4;
              return LaiseeService.getLaiseeQualList();

            case 4:
              qualList = _context9.sent.order_list;
              // 找到今天的资格订单号
              todayOrderInfo = qualList.find(function (order) {
                return isToday(order.open_time);
              });

              if (todayOrderInfo) {
                _context9.next = 8;
                break;
              }

              return _context9.abrupt("return", null);

            case 8:
              todayOrder = todayOrderInfo.orderid;
              commit('setState', {
                state: 'todayOrder',
                value: todayOrder
              });
              return _context9.abrupt("return", todayOrder);

            case 13:
              _context9.prev = 13;
              _context9.t0 = _context9["catch"](1);
              console.error('getTodayOrder', _context9.t0);
              Vue.prototype.toast('查询红包资格失败，请刷新重试');

            case 17:
              return _context9.abrupt("return", null);

            case 18:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, null, [[1, 13]]);
    }))();
  },
  // 获得所有红包的历史领取列表
  getHistoryRecord: function getHistoryRecord(_ref10) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
      var commit, qualList, orderMap, orderInfoList, historyRecord, promiseList;
      return regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              commit = _ref10.commit;
              qualList = [];
              _context10.prev = 2;
              _context10.next = 5;
              return LaiseeService.getLaiseeQualList();

            case 5:
              qualList = _context10.sent.order_list;
              _context10.next = 13;
              break;

            case 8:
              _context10.prev = 8;
              _context10.t0 = _context10["catch"](2);
              console.error('getLaiseeQualList', _context10.t0); // const code = e.code || e.ret;
              // const codeMsg = code ? `(${code})` : '';

              Vue.prototype.toast('服务器开小差了，请稍后刷新重试');
              return _context10.abrupt("return");

            case 13:
              if (!(qualList.length === 0)) {
                _context10.next = 15;
                break;
              }

              return _context10.abrupt("return");

            case 15:
              // 非今日的订单map
              orderMap = {};
              qualList.forEach(function (qualOrder) {
                if (isToday(qualOrder.open_time)) {
                  // 今日订单保存，后续用来读取或创建对应红包
                  commit('setState', {
                    state: 'todayOrder',
                    value: qualOrder.orderid
                  });
                } else {
                  // 非今日订单，记录，后续得到对应的红包领取列表
                  orderMap[qualOrder.open_time] = qualOrder.orderid;
                }
              }); // 订单信息列表

              orderInfoList = null;
              _context10.prev = 18;
              _context10.next = 21;
              return LaiseeService.getOrderList();

            case 21:
              orderInfoList = _context10.sent;
              _context10.next = 29;
              break;

            case 24:
              _context10.prev = 24;
              _context10.t1 = _context10["catch"](18);
              console.error('getOrderList', _context10.t1);
              checkError(_context10.t1);
              return _context10.abrupt("return");

            case 29:
              _context10.prev = 29;
              // 非今日的红包id与对应时间戳的列表
              historyRecord = []; // promise 任务列表

              promiseList = []; // 将订单map转换为红包领取记录map

              Object.keys(orderMap).forEach(function (key) {
                // 找到某条订单id所对应的订单信息
                var info = orderInfoList.find(function (info) {
                  return info.order_id === orderMap[key];
                }); // 获得该订单所对应的红包id
                // eslint-disable-next-line camelcase

                var laiseeId = info === null || info === void 0 ? void 0 : info.laisee_id;

                if (!laiseeId) {
                  return;
                } // 保存该红包对应的领取记录


                var getfetcherList = LaiseeService.getfetcherList(laiseeId);
                promiseList.push(getfetcherList);
                getfetcherList.then(function (res) {
                  var list = res.fetcher_list || [];
                  var luckiest = NaN;

                  if (list.length > 0) {
                    luckiest = getLuckiest(list);
                  }

                  historyRecord.push({
                    timestamp: key * 1000,
                    list: list,
                    luckiest: luckiest
                  });
                }).catch(function (e) {
                  console.error('getfetcherList', e);

                  if (![0, -1].includes(e.code)) {
                    Vue.prototype.toast('获取历史红包领取记录失败，请稍后再试');
                  }
                });
              }); // 等待所有红包查询完成

              _context10.next = 35;
              return Promise.all(promiseList);

            case 35:
              // 按时间倒序排列
              historyRecord.sort(function (a, b) {
                return -(a.timestamp - b.timestamp);
              });
              commit('setState', {
                state: 'historyRecord',
                value: historyRecord
              }); // console.debug('historyRecord', historyRecord);

              _context10.next = 43;
              break;

            case 39:
              _context10.prev = 39;
              _context10.t2 = _context10["catch"](29);
              console.error('getHistoryRecord', _context10.t2); // const code = e.code || e.ret;
              // const codeMsg = code ? `(${code})` : '';
              // Vue.prototype.toast(`服务器开小差了，请稍后重试${codeMsg}`);

              Vue.prototype.toast('服务器开小差了，请稍后重试');

            case 43:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, null, [[2, 8], [18, 24], [29, 39]]);
    }))();
  },
  createTodayLaisee: function createTodayLaisee(_ref11) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
      var state, commit, dispatch, res, securityVerify, iRet, sUserMsg, msgMap;
      return regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              state = _ref11.state, commit = _ref11.commit, dispatch = _ref11.dispatch;
              _context11.prev = 1;

              if (!state.todayOrder) {
                _context11.next = 7;
                break;
              }

              // 兜底情况，有今日订单但没有今日红包的异常情况
              console.debug('兜底情况，有今日订单但没有今日红包的异常情况');
              _context11.next = 6;
              return dispatch('createLaisee', state.todayOrder);

            case 6:
              return _context11.abrupt("return");

            case 7:
              _context11.next = 9;
              return LaiseeService.writeLaiseeQual();

            case 9:
              res = _context11.sent;

              if (res.orderid) {
                _context11.next = 13;
                break;
              }

              Vue.prototype.toast('创建红包失败，请稍后再试');
              throw res;

            case 13:
              // 保存今日订单
              commit('setState', {
                state: 'todayOrder',
                value: res.orderid
              }); // 拿着该订单去创建红包

              _context11.next = 16;
              return dispatch('createLaisee', state.todayOrder);

            case 16:
              _context11.next = 34;
              break;

            case 18:
              _context11.prev = 18;
              _context11.t0 = _context11["catch"](1);

              if (!_context11.t0.sec_info) {
                _context11.next = 30;
                break;
              }

              securityVerify = JSON.parse(_context11.t0.sec_info);
              iRet = securityVerify.iRet, sUserMsg = securityVerify.sUserMsg; // 黑产，直接ban

              if (!(iRet === 101)) {
                _context11.next = 26;
                break;
              }

              // Vue.prototype.toast(sUserMsg || '您的账号存在风险，请切换账号后重试');
              Vue.prototype.eventBus.$emit('showDanger');
              return _context11.abrupt("return");

            case 26:
              if (!iRet) {
                _context11.next = 28;
                break;
              }

              return _context11.abrupt("return", new Promise(function (resolve) {
                shieldRun(securityVerify, function () {
                  // 验证成功，则递归执行一遍创建红包行为
                  dispatch('createTodayLaisee').then(resolve);
                }, // async () => {
                //   await dispatch('createTodayLaisee');
                //   resolve(); // 结束递归
                // },
                resolve // 用户取消验证，也结束创建红包
                );
              }));

            case 28:
              // 兜底情况
              Vue.prototype.toast(sUserMsg || "\u7CFB\u7EDF\u5F00\u5C0F\u5DEE\u4E86\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5[".concat(_context11.t0.ret || _context11.t0.code, "]"));
              return _context11.abrupt("return");

            case 30:
              console.log('----test---'); // 接口报错

              msgMap = {
                '-100012': '今日参与活动的次数达到上限了哦~',
                '-100013': '参与本次活动的次数达到上限了哦~',
                '-100014': '今日红包已发完，明天再来吧~',
                default: '啊哦，出了点小问题，请刷新重试'
              };
              Vue.prototype.toast(msgMap[_context11.t0.ret || _context11.t0.code] || msgMap.default);
              console.error('createTodayLaisee', _context11.t0);

            case 34:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, null, [[1, 18]]);
    }))();
  },

  /**
   * 更新领取列表
   */
  updateFetcherList: function updateFetcherList(_ref12) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
      var state, commit, res;
      return regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              state = _ref12.state, commit = _ref12.commit;

              if (state.todayLaisee) {
                _context12.next = 3;
                break;
              }

              return _context12.abrupt("return");

            case 3:
              _context12.prev = 3;
              _context12.next = 6;
              return LaiseeService.getfetcherList(state.todayLaisee);

            case 6:
              res = _context12.sent;
              commit('setState', {
                state: 'fetcherList',
                value: res.fetcher_list || []
              }); // this.isFinish = !res.isFinish; // 后台接口逻辑历史遗留问题，isFinish为0的时候表示已领取完
              // if (res?.isFinish === 1) {
              //   Vue.prototype.eventBus.$emit('getWalletBalance');
              // }

              _context12.next = 14;
              break;

            case 10:
              _context12.prev = 10;
              _context12.t0 = _context12["catch"](3);

              if (![0, -1].includes(_context12.t0.code)) {
                Vue.prototype.toast('获取历史红包领取记录失败，请稍后再试');
              }

              console.error(_context12.t0);

            case 14:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, null, [[3, 10]]);
    }))();
  },
  getAppInstall: function getAppInstall(_ref13) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
      var commit, res;
      return regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              commit = _ref13.commit;

              if (!env.isApp) {
                _context13.next = 6;
                break;
              }

              _context13.next = 4;
              return isKidAppExisted();

            case 4:
              res = _context13.sent;
              commit('setState', {
                state: 'isKidAppInstall',
                value: res
              });

            case 6:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13);
    }))();
  }
};
export default new Vuex.Store({
  state: state,
  mutations: mutations,
  actions: actions
});